/**
 * Abre una aplicación en su pestaña con nombre, sin recargarla si ya existe.
 *
 * Un enlace con target="nombre" navega esa pestaña a la dirección, y eso la
 * recarga (se pierde lo que se estaba haciendo). `window.open('', nombre)`
 * en cambio devuelve la pestaña que ya tiene ese nombre sin tocarla; si no
 * existe, abre una vacía (about:blank) y solo entonces se le pone la
 * dirección.
 */
export function abrirEnPestana(url, nombre) {
  const w = window.open('', nombre);
  if (!w) { window.location.href = url; return; }      // ventanas emergentes bloqueadas
  let nueva = false;
  try { nueva = w.location.href === 'about:blank'; } catch { nueva = false; }
  // Si leer su dirección falla es porque ya está en otro sitio (la aplicación
  // abierta): se deja como está.
  if (nueva) w.location.href = url;
  w.focus();
}
